<template>
  <v-layout align-end>
    <app-reference
      v-model="country"
      class="ma-0"
      label="Направление"
      resource="countries"
      component-name="Country"
      :outline="true"
      :height-field="44"
      @input="changeDirection"
    />
  </v-layout>
</template>

<script>
export default {
  props: ["direction"],
  data() {
    return {
      country: null,
    };
  },
  watch: {
    direction: {
      handler() {
        this.country = this.direction ? this.direction[0] : null;
      },
      deep: true,
    },
  },
  methods: {
    changeDirection() {
      this.$emit("input", this.country);
    },
  },
};
</script>
